import React, { Component } from "react"
import Calendar from "../../components/Calendar"
import { Helmet } from "react-helmet"
import { MetaData, structuredPageData } from "../../shared/structureData"
import { Mutation } from "react-apollo"
import qs from "qs"
import moment from "moment"
import PurchaseCard from "../../components/PurchaseCard"
import Modal from "../../components/Modal"
import RequestAccessModal from "../../components/RequestAccessModal"
import { defaultLogo } from "../../shared/images"
import REQUEST_REPORT_ACCESS from "../../graphql/requestReportAccess.graphql"
import { EtrInsightsCalendarEventInfo } from "./EtrInsightsCalendarEventInfo"
import { EtrInsightsCalendarPurchaseCardsSection } from "./EtrInsightsCalendarPurchaseCardsSection"

class CalendarEvent extends Component {
  isBefore
  constructor(props) {
    super(props)
    this.state = {
      eventDate: null,
      isModalOpen: false,
      isRequestAccess: false,
      isRequestAccessSuccess: false,
      eventDisplay: 0,
      selectedFile: 0,
      selectedDay: moment(),
      products: [],
      eventType: "",
      selectedProduct: {},
    }
  }

  /**
   * [getEvents description]
   *
   */
  getEvents = () => {
    let dateContext = Object.assign({}, this.state.selectedDay)
    let events = []

    if (Array.isArray(this.props.data.products)) {
      this.props.data.products.map((event) => {
        if (
          moment.utc(event.metadata["Event Date"]).format("MM/DD/YYYY") ===
          moment(dateContext).format("MM/DD/YYYY")
        ) {
          events.push(event)
        }
      })
    }
    return events
  }

  pageSEO = () => {
    let seo = {}
    seo.type = "website"
    seo.url = "https://app.etr.ai/etr-insights/calendar"
    seo.title = `ETR Insights Calendar | ETR`
    seo.image = defaultLogo
    seo.description =
      "RSVP to the next enterprise technology market defining discussion by ETR's VENN, or get the executive summary, full transcript, and replay - on demand."

    return (
      <Helmet>
        {MetaData(seo)}
        <script type="application/ld+json">
          {structuredPageData(seo.url)}
        </script>
      </Helmet>
    )
  }

  eventType = (day) => {
    const { products } = this.props.data
    let selected = null
    let eventType

    products.map((product) => {
      let ISODate = new Date(product.publishDate).toISOString()
      if (
        moment(ISODate).format("MM/DD/YYY") === moment(day).format("MM/DD/YYY")
      ) {
        selected = product
      }
    })

    if (selected === null) {
      eventType = ""
    } else {
      eventType = selected.metadata["Event Location"]
    }

    return eventType
  }

  /**
   * [onDayClick description]
   * update the state with the clicked day on the calendar
   */
  onDayClick = (e, day) => {
    let eventType = this.eventType(day)
    this.setState({
      selectedDay: day,
      eventType: eventType,
      eventDisplay: 0,
    })
  }

  /**
   * [currentMonth description]
   * update the selected month
   * this will update the filters state on parent component with the selected month
   * updating the filters on state will result on a query from the db
   */
  updateMonth = (month) => {
    let dateContext = Object.assign({}, month)

    this.setState((prevState) => {
      return {
        dateContext: moment(dateContext),
      }
    }, this.props.fetchVennProducts(this.state.dateContext))
  }

  /**
   * [view description]
   * @param  {[type]} product  [venn event product]
   * @param  {[type]} item     [selected file]
   * build url with venn event information
   * and redirect user to view the file
   */
  view = (product, item) => {
    let { isSpecialAccess, files, name, id, proprietaryDataset, free } = product

    if (!isSpecialAccess && !free) {
      alert("You have not purchased this report!")
    } else if (!files || !files[item || 0]) {
      alert("This report is not yet available to view")
    } else {
      this.props.trackEvent("Viewed report", {
        productName: name,
        productId: id,
        productType: proprietaryDataset,
        file: files && files[item || 0].name,
      })
      this.props.history.push({
        pathname: "/marketplace/" + product.slug[0] + "/view",
        search: item && qs.stringify({ item }, { addQueryPrefix: true }),
      })
    }
  }

  /**
   * [download description]
   * allow client to download report
   */
  download = (selection, product) => (e) => {
    let { isSpecialAccess, files, name, id, proprietaryDataset, free } = product
    if (!isSpecialAccess && !free) {
      e.preventDefault()
      alert("You have not purchased this report!")
    } else if (!files || !files[selection || 0]) {
      e.preventDefault()
      alert("This report is not yet available to download")
    } else {
      this.props.trackEvent("Downloaded report", {
        productName: name,
        productId: id,
        productType: proprietaryDataset,
        file: files && files[selection || 0].name,
      })
    }
  }

  /**
   * [trackEvent description]
   * @param  {[type]} message [message for tracking]
   * @param  {[type]} product [product data]
   * track analitics
   */

  trackEvent = (message, product) => {
    let eventBody = {
      productName: product.name,
      productId: product.id,
      productType: product.proprietaryDataset,
    }
    this.props.trackEvent(message, eventBody)
  }

  /**
   * [selectFile description]
   * select the file option from the dropdown menu
   * on the purchase card dropdown menu ie[0,1,2]
   */
  selectFile = (e) => {
    this.setState({
      selectedFile: e.value,
    })
  }

  isProductAvailable = (product) => {
    let { metadata } = product
    let date =
      metadata && metadata["Event Date"] && moment.utc(metadata["Event Date"])

    return moment(date).isBefore(moment())
  }

  _renderRequestAccess = (product) => {
    return (
      <PurchaseCard
        buttonClasses={["btn", "btn-light", "btn-outline"]}
        buttonText="REQUEST ACCESS"
        buttonAction={() => this.openRequestAccessModal(product)}
      />
    )
  }

  /**
   * [_renderPurchaseCards description]
   * render the pruchase options for the event
   * displays on the sidebar of the calendar
   * renders under the event description
   */
  _renderPurchaseCards = (product) => {
    let { isSpecialAccess, files, free, slug } = product

    let { selectedFile } = this.state
    const model = {
      slug,
      free,
      files,
      product,
      selectedFile,
      isSpecialAccess,
      selectFile: this.selectFile,
      download: this.download,
      isProductAvailable: this.isProductAvailable,
      renderRequestAccess: this._renderRequestAccess,
      view: this.view,
    }
    return <EtrInsightsCalendarPurchaseCardsSection model={model} />
  }

  /**
   * [openRequestAccessModal description]
   * @param  {[type]} product [needs product to get info of selected product]
   * open request Access modal and also takes a product for track and set it
   * as selected product
   */
  openRequestAccessModal = (product) => {
    this.trackEvent("Clicked Request Event Access", product)
    this.setState({
      selectedProduct: product,
      isModalOpen: true,
      isRequestAccess: true,
      isRequestAccessSuccess: false,
    })
  }

  /**
   * [requestEventAccess description]
   * @param  {[type]} args [arguments from the form when requesting access]
   * uses the requestAccessToProduct on api
   * mutation that send email to VENN requesting product access
   */
  requestEventAccess = (args) => {
    this.props
      .requestAccess({
        variables: {
          type: "venn-access",
          productId: this.state.selectedProduct.id,
          name: `${args.first} ${args.last}`,
          time: moment(args.time, "HH:mm").utc().format("HH:mm"),
          ...args,
        },
      })
      .then(({ data }) => {
        if (data.requestAccessToProduct.payload === "success") {
          this.trackEvent("Requested Event Access", this.state.selectedProduct)
          this.setState({ requestAccessSuccess: true })
        } else {
          alert(
            `Unable to process your request: ${data.requestAccessToProduct.message}`
          )
        }
      })
      .catch((_) => alert("Unable to process your request"))

    this.setState({
      isRequestAccessSuccess: true,
    })
  }
  /**
   * [closeModal description]
   */
  closeModal = () =>
    this.setState({
      isModalOpen: false,
      isRequestAccess: false,
      isRequestAccessSuccess: false,
    })

  /**
   * [eventDisplay]
   * switch between event on the sidebar of calendar
   */
  eventDisplay = () => {
    return this.state.eventDisplay * 100
  }
  /**
   * [nextEvent description]
   * On the right sidebar of the calendar
   * when 2 or more events on that day show next product
   */
  nextEvent = (events) => {
    let numOfEvents = events.length
    let current = this.state.eventDisplay

    if (current < numOfEvents - 1) {
      this.setState((prevState) => {
        return { eventDisplay: prevState.eventDisplay + 1 }
      })
    }
  }

  /**
   * [prevEvent description]
   * On the right sidebar of the calendar
   * when 2 or more events on that day show prev product
   */
  prevEvent = (events) => {
    let numOfEvents = events.length
    let current = this.state.eventDisplay

    if (current >= numOfEvents - 1) {
      this.setState((prevState) => {
        return { eventDisplay: prevState.eventDisplay - 1 }
      })
    }
  }

  /**
   * [_renderEventNav description]
   * @param  {[type]} events [array with all of the event dates for the month]
   * display header for the right sidebar of calendar
   * displays the next and prev options
   */
  _renderEventNav = (events) => {
    if (events.length > 1) {
      return (
        <div className="event-nav col-left">
          <span
            className={`btn-prev ${
              this.state.eventDisplay === 0 ? "disabled" : ""
            }`}
            onClick={() => this.prevEvent(events)}
          >
            <i className="fa fa-chevron-left icon" />
            Prev
          </span>

          <span
            className={`btn-next ${
              this.state.eventDisplay === events.length - 1 ? "disabled" : ""
            }`}
            onClick={() => this.nextEvent(events)}
          >
            Next
            <i className="fa fa-chevron-right icon" />
          </span>
        </div>
      )
    }
    return null
  }

  /**
   * [renderEventInfo ]
   * render the event information that is on the right
   * sidebar of the calendar
   */
  renderEventInfo = () => {
    let events = this.getEvents()
    if (this.getEvents().length === 0) {
      // return <div className="no-data"> No Event available on {moment(this.state.selectedDay).format('MM/D/YYYY')} </div>
      return <div className="no-data">Select An Event To See Information</div>
    }

    if (events.length > 1) {
      // if array has more than 1 event in a day sort by time on event
      events.sort((a, b) => {
        return (
          moment(a.metadata["Event Time"], "hh:mmA") -
          moment(b.metadata["Event Time"], "hh:mmA")
        )
      })
    }
    let event = events[this.state.eventDisplay]

    let {
      Speakers,
      ["Event Date"]: eventDate,
      ["Event Location"]: eventLocation,
      ["Event Time"]: eventTime,
      ["Event Signup URI"]: eventSignupUri,
      Organization,
    } = event.metadata

    const model = {
      renderEventNav: this._renderEventNav,
      renderPurchaseCards: this._renderPurchaseCards,
      Speakers,
      Organization,
      event,
      events,
      eventLocation,
      eventTime,
      eventDate,
      eventSignupUri,
      onSignUp: () => window.open(eventSignupUri, "_blank"),
    }
    return <EtrInsightsCalendarEventInfo model={model} />
  }

  /**
   * [getProducts description]
   * gets the event dates and place them on array to
   * pass them to the calendar
   */
  getEventDates = () => {
    let { products } = this.props.data
    let eventDates = []

    if (Array.isArray(products))
      products.map((product) => {
        eventDates.push(product.metadata["Event Date"])
      })

    return eventDates
  }

  onLinkClicked = (e, description, from, url) => {
    e.preventDefault()
    this.props.trackEvent(event, {
      from: from,
    })
    this.props.history.push(url)
  }

  render() {
    let { eventType } = this.state

    let calendarBgImage

    if (eventType.length === 0) {
      calendarBgImage = "image-event-web"
    } else {
      eventType.toLowerCase() === "webinar" || eventType.toLowerCase() === "tbd"
        ? (calendarBgImage = "image-event-web")
        : (calendarBgImage = "image-event-diner")
    }

    return (
      <div className={`venn-calendar-wrap ${calendarBgImage}`}>
        <section id="venn-calendar">
          {this.pageSEO()}
          <div className="venn-calendar-row">
            <div className="venn-calendar-cell">
              <Calendar
                selectedDay={this.state.selectedDay}
                dateContext={this.props.selectedMonth}
                onCalendarUpdate={(month) => this.props.setMonth(month)}
                className="venn-calendar"
                eventDates={this.getEventDates()}
                onDayClick={(e, day) => this.onDayClick(e, day)}
              />
            </div>
            <div
              className={`venn-calendar-cell venn-calendar-info ${calendarBgImage}`}
            >
              <aside className="venn-event-info">
                {this.renderEventInfo()}
              </aside>
            </div>
          </div>
        </section>
        <div className="venn-links">
          <a
            className="btn btn-light btn-outline"
            onClick={(e) =>
              this.onLinkClicked(
                e,
                "Learn ETR Insights Button",
                "ETR Insights Calendar",
                "/etr-insights/about"
              )
            }
          >
            Learn About ETR Insights
            <span className="fa fa-arrow-right icon hover-animate" />
          </a>
          <a
            className="btn btn-secondary"
            onClick={(e) =>
              this.onLinkClicked(
                e,
                "Search All Venn Events button",
                "VENN Calendar",
                "/marketplace?reportType=VENN"
              )
            }
          >
            Search All ETR Insights Events
            <span className="fa fa-arrow-right icon hover-animate" />
          </a>
        </div>
        <Modal
          isOpen={this.state.isModalOpen}
          close={this.closeModal}
          classes={["medium"]}
        >
          {this.state.isRequestAccess && (
            <RequestAccessModal
              close={this.closeModal}
              submit={this.requestEventAccess}
              success={this.state.isRequestAccessSuccess}
              successMessage="A member from our team will reach out to you shortly"
            />
          )}
        </Modal>
      </div>
    )
  }
}

const CalendarEventWidthData = (props) => {
  return (
    <Mutation mutation={REQUEST_REPORT_ACCESS} fetchPolicy="network-only">
      {(mutate) => <CalendarEvent {...props} requestAccess={mutate} />}
    </Mutation>
  )
}

export default CalendarEventWidthData
